import { useAuthenticatedFetch } from "@stardeck-customer-apps/project-auth";
import { useMutation } from "@tanstack/react-query";

import { queryKeys } from "./query-keys";

interface Coupon {
  uuid: string;
  couponNumber: number;
}

interface PropertyPurchaseData {
  id: number;
  developer: string;
  full_address: string;
  purchase_price: number;
}

interface RegistrationData {
  name: string;
  surname: string;
  phone: string;
}

interface PrintCouponsResponse {
  coupons: Coupon[];
  property_purchase: PropertyPurchaseData;
  registration: RegistrationData;
}

export function usePrintCoupons(propertyPurchaseId: string | undefined) {
  const authenticatedFetch = useAuthenticatedFetch();

  return useMutation({
    mutationKey: propertyPurchaseId ? queryKeys.printCoupons.detail(propertyPurchaseId) : undefined,
    mutationFn: async () => {
      if (!propertyPurchaseId) {
        throw new Error("Property purchase ID is required");
      }

      const response = await authenticatedFetch(
        `/api/admin/property-purchases/${propertyPurchaseId}/print-coupons`,
        {
          method: "PATCH",
        }
      );

      if (!response.ok) {
        const errorData = (await response.json()) as { message?: string };
        throw new Error(errorData.message || "Failed to print coupons");
      }

      return response.json() as Promise<PrintCouponsResponse>;
    },
  });
}
